import { render, staticRenderFns } from "./rolePicker.vue?vue&type=template&id=ecf728fc&scoped=true"
import script from "./rolePicker.vue?vue&type=script&lang=js"
export * from "./rolePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf728fc",
  null
  
)

export default component.exports